import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { SpeechRecognitionService } from '../services/speech-recognition.service';

@Component({
  selector: 'app-custom-popup',
  templateUrl: './custom-popup.component.html',
  styleUrls: ['./custom-popup.component.css']
})
export class CustomPopupComponent implements OnInit, AfterViewInit {

  @ViewChild('text') textbox: ElementRef;
  
  title: string;
  content: any;
  options: string[];
  answer:string;
  inputText:string;
  selectedItem:string;
  isInputEmpty:boolean = false;
  respondObject:Object = {};
  exampleList:any;
  optionList:CustomOptionObject[] = [];
  option:Option;

  constructor(
    public bsModalRef: BsModalRef,
    private speechRecognitionService:SpeechRecognitionService) { }

  ngOnInit() {
    this.buildOptionList();
  }

  ngAfterViewInit(){
    const inputElem = <HTMLInputElement>this.textbox.nativeElement;
    inputElem.select();
  }
  
  respond(answer: string) {
    if(!this.inputText && answer == "OK"){
      this.isInputEmpty = true;
    }else {
      this.answer = answer;
      this.respondObject = {"filter": this.option.SelectedItem, "value": this.inputText };
      this.bsModalRef.hide();
    }
  }

  onChange(){
    if (!this.inputText){
      this.isInputEmpty = true;
    }
    else {
      this.isInputEmpty = false;
    }
  }

  enter(value: string){
    this.inputText = value;
    this.respond("OK");
  }

  buildOptionList(){
    this.optionList.push({ItemDisplay: "Equals", ItemValue: "EQUALS"});
    this.optionList.push({ItemDisplay: "Not Equals", ItemValue: "NOTEQUALS"});
    this.optionList.push({ItemDisplay: "Contains", ItemValue: "CONTAINS"});
    this.optionList.push({ItemDisplay: "Not Contain", ItemValue: "NOTCONTAINS"});
    this.optionList.push({ItemDisplay: "Starts With", ItemValue: "STARTSWITH"});
    this.optionList.push({ItemDisplay: "Ends With", ItemValue: "ENDSWITH"});
    this.optionList.push({ItemDisplay: "Greater Than", ItemValue: "GREATERTHAN"});
    this.optionList.push({ItemDisplay: "Greater Than Equals", ItemValue: "GREATERTHANEQUALS"});
    this.optionList.push({ItemDisplay: "Less Than", ItemValue: "LESSTHAN"});
    this.optionList.push({ItemDisplay: "Less Than Equals", ItemValue: "LESSTHANEQUALS"});
    this.optionList.push({ItemDisplay: "In", ItemValue: "IN"});
    this.option = new Option();
    if (this.selectedItem){
      this.option.SelectedItem = this.selectedItem;
    }
    else{
      this.option.SelectedItem = "EQUALS";
    }
  }

  clearFilter(){
    this.answer = "CLEAR";
    this.respondObject = {"clearFilter": true };
    this.bsModalRef.hide();
  }
}

export class Option {
  SelectedItem: string;
  CustomOptionObject:CustomOptionObject[];
}

export class CustomOptionObject {
  ItemValue:string;
  ItemDisplay:string
}
